module.exports = __webpack_public_path__ + "img/file_download_white_24dp.acdf26c5.svg";